export default {
  gift_card_removed: 'Carte cadeau supprimée',
  invalid_gift_card: 'Carte cadeau invalide',
  gift_card_applied: 'Carte cadeau appliquée',
};
